import React, {memo} from "react";
import {Button, Modal} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeDataCarrotWallet, handelCloseModalMyCarrotWallet} from "../../../../../redux/actions/modals/modalMyCarrotWallet";
import TitlesModals from "../TitlesModals";
import axios from "axios";
import {BASE_URL, USERS_TRANSACTIONS_POST} from "../../../../../apis";
import qs from "querystring";
import InfiniteScroll from 'react-infinite-scroll-component';

import LoaderModals from "../../loaders/LoaderModals";
import {FaTimesCircle} from "react-icons/all";


const ModalMyCarrotWallet = () => {
    const dispatch = useDispatch()
    const {statusShow, transactions, total, total_rows, offset,loader} = useSelector(state => state.modalMyCarrotWallet);
    
    
    const {token} = useSelector(state => state.user);
    const handleClose = () => {
        dispatch(handelCloseModalMyCarrotWallet());
    };



    const apiGetListTransactions = () => {
            axios({
                method: 'post',
                url: BASE_URL + USERS_TRANSACTIONS_POST,
                data: qs.stringify({offset}),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': token
                },
            }).then((response) => {
                if (response.data.status === 'ok') {
                const {transactions: transactions_api, total: total_api, total_rows: total_rows_api} = response.data;
                    dispatch(actionChangeDataCarrotWallet(transactions.concat(transactions_api), total_api, total_rows_api, (offset + 15)));
                }
            });
    };

    return (
        <div>
            <BaseModal title={'کیف هویج من'}
                       show={statusShow}
                       dialogClassName={''}
                       handleClose={handleClose}>
                <Modal.Body id={"scrollableDiv"}>
                    {!loader ?
                    <div>
                        <div><TitlesModals>تراکنش ها</TitlesModals></div>
                        {transactions.length > 0 ?
                            <InfiniteScroll
                                dataLength={offset}
                                next={apiGetListTransactions}
                                hasMore={transactions.length < total_rows}
                                loader={<h5 className={'text-center text-success mt-1'}>درحال بارگزاری ...</h5>}
                                scrollableTarget="scrollableDiv"
                            >
                                {transactions.map((transaction, index) => (
                                    <div key={index} className={'pb-3 mt-1 border-bottom'}>
                                        <div>
                                            <span className={'ml-2'}><b>{transaction.description}</b></span>
                                            <span
                                                className={`float-left mr-2 ${transaction.amount >= 0 ? 'text-success' : 'text-danger'}`}><b>{transaction.amount.toLocaleString()}</b></span>
                                        </div>
                                        <div>
                                            <span className={'float-left mr-2'}><b>{transaction.date}</b></span>
                                        </div>
                                        <br/>
                                    </div>
                                ))}
                            </InfiniteScroll>
                            :
                            <div className={'box-not-find-transaction-modal-wallet'}>
                                <div className={'not-find-transaction-modal-wallet'}>
                                    <FaTimesCircle className={'icon-not-find-transaction-modal-wallet'}/>
                                    <p>تراکنشی وجود ندارد</p>
                                </div>
                            </div>
                        }

                    </div>
                        : <LoaderModals/>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className={'base-btn-green'} block>
                        <span className={'float-right'}>موجودی کیف هویج</span>
                        <span className={'float-left price-show-data-btn-footer-modal-wallet base-green-dark'}>
                            <span style={{unicodeBidi: "bidi-override", direction: "ltr"}}>{total.toLocaleString()}</span>
                            <span> هویج </span>
                        </span>
                    </Button>
                </Modal.Footer>
            </BaseModal>
        </div>
    );
};

export default memo(ModalMyCarrotWallet);
